import {
  repoSendEmail,
} from "../Repositories/Email";


export const sendEmail = async (dataEmail) => {
  try {
    const response = await repoSendEmail(dataEmail);
    return response;
  } catch (error) {
    throw error.response;
  }
};
